import { LEAVE_BADGE } from "./reportTokens";

// بطاقات KPI وشارات الإجازات المشتركة بين تفاصيل الرواتب والحضور داخل الصفحة.
export const DetailCards = ({ items }) => (
  <dl className="grid grid-cols-2 gap-3 sm:grid-cols-4">
    {items.map(([label, value, tone]) => (
      <div key={label} className="neu-in rounded-2xl px-4 py-3">
        <dt className="text-[10px] tracking-normal text-muted-foreground">{label}</dt>
        <dd
          className={`mt-1 font-mono text-lg font-black ${
            tone === "bad" ? "text-destructive" : tone === "good" ? "text-primary" : ""
          }`}
          data-testid={`detail-card-${label}`}
        >
          {value}
        </dd>
      </div>
    ))}
  </dl>
);

export const LeaveBadges = ({ breakdown, labels }) => (
  <span className="flex flex-wrap gap-1">
    {Object.entries(breakdown || {})
      .filter(([, item]) => item.count > 0)
      .map(([kind, item]) => {
        const [bg, fg] = LEAVE_BADGE[kind] || LEAVE_BADGE.unpaid;
        return (
          <span
            key={kind}
            className="rounded-full px-2 py-0.5 text-[10px] font-bold"
            style={{ background: bg, color: fg }}
          >
            {labels[kind] || kind} {item.count}
          </span>
        );
      })}
  </span>
);
